export { RouteAnnouncer, getRouteAnnouncement } from './RouteAnnouncer';
export type { RouteAnnouncementKey, RouteAnnouncerProps } from './types';
